type TableLoadingRowProps = {
    colSpan: number;
    label?: string;
};

export default function TableLoadingRow({ colSpan, label = "Loading..." }: TableLoadingRowProps) {
    return (
        <tr>
            <td colSpan={colSpan} className="px-4 py-10 text-center">
                <div className="flex items-center justify-center gap-3 text-sm font-medium text-gray-500" role="status" aria-live="polite">
                    <svg className="h-6 w-6 animate-spin text-[#ac120c]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle className="opacity-20" cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="4" />
                        <path fill="currentColor" d="M12 3a9 9 0 0 1 9 9h-4a5 5 0 0 0-5-5V3Z" />
                    </svg>
                    <span>{label}</span>
                </div>
            </td>
        </tr>
    );
}
